/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  DataResponseStipendDetailsRead,
  ErrorResponse,
  GetStipendConfigStipendsConfigGetParams,
  HTTPValidationError,
  SendStipendRequest,
  StipendAction,
  StipendConfigRequest,
  StipendConfigResponse,
  StipendDetailsRead,
  StipendRead,
} from "../../model";
import type { ErrorType, BodyType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get Stipend Config
 */
export const getStipendConfigStipendsConfigGet = (
  params?: GetStipendConfigStipendsConfigGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<StipendConfigResponse>(
    { url: `/stipends/config`, method: "GET", params, signal },
    options
  );
};

export const getGetStipendConfigStipendsConfigGetQueryKey = (
  params?: GetStipendConfigStipendsConfigGetParams
) => {
  return [`/stipends/config`, ...(params ? [params] : [])] as const;
};

export const getGetStipendConfigStipendsConfigGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetStipendConfigStipendsConfigGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStipendConfigStipendsConfigGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>
  > = ({ signal }) =>
    getStipendConfigStipendsConfigGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStipendConfigStipendsConfigGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>
>;
export type GetStipendConfigStipendsConfigGetQueryError =
  ErrorType<ErrorResponse>;

export function useGetStipendConfigStipendsConfigGet<
  TData = Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  params: undefined | GetStipendConfigStipendsConfigGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStipendConfigStipendsConfigGet<
  TData = Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetStipendConfigStipendsConfigGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
          TError,
          Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStipendConfigStipendsConfigGet<
  TData = Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetStipendConfigStipendsConfigGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stipend Config
 */

export function useGetStipendConfigStipendsConfigGet<
  TData = Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
  TError = ErrorType<ErrorResponse>,
>(
  params?: GetStipendConfigStipendsConfigGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendConfigStipendsConfigGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetStipendConfigStipendsConfigGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Configure Stipends
 */
export const configureStipendsStipendsConfigPut = (
  stipendConfigRequest: BodyType<StipendConfigRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<StipendConfigResponse>(
    {
      url: `/stipends/config`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: stipendConfigRequest,
      signal,
    },
    options
  );
};

export const getConfigureStipendsStipendsConfigPutMutationKey = () =>
  ["configureStipendsStipendsConfigPut"] as const;

export const getConfigureStipendsStipendsConfigPutMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof configureStipendsStipendsConfigPut>>,
    TError,
    ConfigureStipendsStipendsConfigPutMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof configureStipendsStipendsConfigPut>>,
  TError,
  ConfigureStipendsStipendsConfigPutMutationVariables,
  TContext
> => {
  const mutationKey = getConfigureStipendsStipendsConfigPutMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof configureStipendsStipendsConfigPut>>,
    ConfigureStipendsStipendsConfigPutMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return configureStipendsStipendsConfigPut(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfigureStipendsStipendsConfigPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof configureStipendsStipendsConfigPut>>
>;
export type ConfigureStipendsStipendsConfigPutMutationBody =
  BodyType<StipendConfigRequest>;
export type ConfigureStipendsStipendsConfigPutMutationError =
  ErrorType<ErrorResponse>;
export interface ConfigureStipendsStipendsConfigPutMutationVariables {
  data: BodyType<StipendConfigRequest>;
}

/**
 * @summary Configure Stipends
 */
export const useConfigureStipendsStipendsConfigPut = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof configureStipendsStipendsConfigPut>>,
      TError,
      ConfigureStipendsStipendsConfigPutMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof configureStipendsStipendsConfigPut>>,
  TError,
  ConfigureStipendsStipendsConfigPutMutationVariables,
  TContext
> => {
  return useMutation(
    getConfigureStipendsStipendsConfigPutMutationOptions(options),
    queryClient
  );
};
/**
 * A participant gets `created_by_user` as null.
 * @summary Get Stipend Details Route
 */
export const getStipendDetailsRouteStipendsStipendIdGet = (
  stipendId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<DataResponseStipendDetailsRead>(
    { url: `/stipends/${stipendId}`, method: "GET", signal },
    options
  );
};

export const getGetStipendDetailsRouteStipendsStipendIdGetQueryKey = (
  stipendId: string
) => {
  return [`/stipends/${stipendId}`] as const;
};

export const getGetStipendDetailsRouteStipendsStipendIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  stipendId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetStipendDetailsRouteStipendsStipendIdGetQueryKey(stipendId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>
  > = ({ signal }) =>
    getStipendDetailsRouteStipendsStipendIdGet(
      stipendId,
      requestOptions,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: stipendId !== null && stipendId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetStipendDetailsRouteStipendsStipendIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>
>;
export type GetStipendDetailsRouteStipendsStipendIdGetQueryError = ErrorType<
  ErrorResponse | HTTPValidationError
>;

export function useGetStipendDetailsRouteStipendsStipendIdGet<
  TData = Awaited<
    ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  stipendId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>
          >,
          TError,
          Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStipendDetailsRouteStipendsStipendIdGet<
  TData = Awaited<
    ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  stipendId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>
          >,
          TError,
          Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetStipendDetailsRouteStipendsStipendIdGet<
  TData = Awaited<
    ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  stipendId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Stipend Details Route
 */

export function useGetStipendDetailsRouteStipendsStipendIdGet<
  TData = Awaited<
    ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>
  >,
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
>(
  stipendId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getStipendDetailsRouteStipendsStipendIdGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetStipendDetailsRouteStipendsStipendIdGetQueryOptions(
      stipendId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Cancel Stipend
 */
export const cancelStipendStipendsStipendIdDelete = (
  stipendId: string,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<void>(
    { url: `/stipends/${stipendId}`, method: "DELETE", signal },
    options
  );
};

export const getCancelStipendStipendsStipendIdDeleteMutationKey = () =>
  ["cancelStipendStipendsStipendIdDelete"] as const;

export const getCancelStipendStipendsStipendIdDeleteMutationOptions = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelStipendStipendsStipendIdDelete>>,
    TError,
    CancelStipendStipendsStipendIdDeleteMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelStipendStipendsStipendIdDelete>>,
  TError,
  CancelStipendStipendsStipendIdDeleteMutationVariables,
  TContext
> => {
  const mutationKey = getCancelStipendStipendsStipendIdDeleteMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelStipendStipendsStipendIdDelete>>,
    CancelStipendStipendsStipendIdDeleteMutationVariables
  > = (props) => {
    const { stipendId } = props ?? {};

    return cancelStipendStipendsStipendIdDelete(stipendId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelStipendStipendsStipendIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelStipendStipendsStipendIdDelete>>
>;

export type CancelStipendStipendsStipendIdDeleteMutationError = ErrorType<
  ErrorResponse | HTTPValidationError
>;
export interface CancelStipendStipendsStipendIdDeleteMutationVariables {
  stipendId: string;
}

/**
 * @summary Cancel Stipend
 */
export const useCancelStipendStipendsStipendIdDelete = <
  TError = ErrorType<ErrorResponse | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelStipendStipendsStipendIdDelete>>,
      TError,
      CancelStipendStipendsStipendIdDeleteMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof cancelStipendStipendsStipendIdDelete>>,
  TError,
  CancelStipendStipendsStipendIdDeleteMutationVariables,
  TContext
> => {
  return useMutation(
    getCancelStipendStipendsStipendIdDeleteMutationOptions(options),
    queryClient
  );
};
/**
 * Create stipend payment for a confirmed participant visit
 * @summary Send Stipend Payment
 */
export const sendStipendPaymentStipendsSendPost = (
  sendStipendRequest: BodyType<SendStipendRequest>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<StipendRead>(
    {
      url: `/stipends/send`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: sendStipendRequest,
      signal,
    },
    options
  );
};

export const getSendStipendPaymentStipendsSendPostMutationKey = () =>
  ["sendStipendPaymentStipendsSendPost"] as const;

export const getSendStipendPaymentStipendsSendPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendStipendPaymentStipendsSendPost>>,
    TError,
    SendStipendPaymentStipendsSendPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendStipendPaymentStipendsSendPost>>,
  TError,
  SendStipendPaymentStipendsSendPostMutationVariables,
  TContext
> => {
  const mutationKey = getSendStipendPaymentStipendsSendPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendStipendPaymentStipendsSendPost>>,
    SendStipendPaymentStipendsSendPostMutationVariables
  > = (props) => {
    const { data } = props ?? {};

    return sendStipendPaymentStipendsSendPost(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendStipendPaymentStipendsSendPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendStipendPaymentStipendsSendPost>>
>;
export type SendStipendPaymentStipendsSendPostMutationBody =
  BodyType<SendStipendRequest>;
export type SendStipendPaymentStipendsSendPostMutationError =
  ErrorType<ErrorResponse>;
export interface SendStipendPaymentStipendsSendPostMutationVariables {
  data: BodyType<SendStipendRequest>;
}

/**
 * @summary Send Stipend Payment
 */
export const useSendStipendPaymentStipendsSendPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendStipendPaymentStipendsSendPost>>,
      TError,
      SendStipendPaymentStipendsSendPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof sendStipendPaymentStipendsSendPost>>,
  TError,
  SendStipendPaymentStipendsSendPostMutationVariables,
  TContext
> => {
  return useMutation(
    getSendStipendPaymentStipendsSendPostMutationOptions(options),
    queryClient
  );
};
/**
 * @summary Action Stipend
 */
export const actionStipendStipendsStipendIdActionPost = (
  stipendId: string,
  stipendAction: BodyType<StipendAction>,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<StipendDetailsRead>(
    {
      url: `/stipends/${stipendId}/action`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: stipendAction,
      signal,
    },
    options
  );
};

export const getActionStipendStipendsStipendIdActionPostMutationKey = () =>
  ["actionStipendStipendsStipendIdActionPost"] as const;

export const getActionStipendStipendsStipendIdActionPostMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof actionStipendStipendsStipendIdActionPost>>,
    TError,
    ActionStipendStipendsStipendIdActionPostMutationVariables,
    TContext
  >;
  request?: SecondParameter<typeof nmibleInstanceV3>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof actionStipendStipendsStipendIdActionPost>>,
  TError,
  ActionStipendStipendsStipendIdActionPostMutationVariables,
  TContext
> => {
  const mutationKey = getActionStipendStipendsStipendIdActionPostMutationKey();
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof actionStipendStipendsStipendIdActionPost>>,
    ActionStipendStipendsStipendIdActionPostMutationVariables
  > = (props) => {
    const { stipendId, data } = props ?? {};

    return actionStipendStipendsStipendIdActionPost(
      stipendId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type ActionStipendStipendsStipendIdActionPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof actionStipendStipendsStipendIdActionPost>>
  >;
export type ActionStipendStipendsStipendIdActionPostMutationBody =
  BodyType<StipendAction>;
export type ActionStipendStipendsStipendIdActionPostMutationError =
  ErrorType<ErrorResponse>;
export interface ActionStipendStipendsStipendIdActionPostMutationVariables {
  stipendId: string;
  data: BodyType<StipendAction>;
}

/**
 * @summary Action Stipend
 */
export const useActionStipendStipendsStipendIdActionPost = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof actionStipendStipendsStipendIdActionPost>>,
      TError,
      ActionStipendStipendsStipendIdActionPostMutationVariables,
      TContext
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof actionStipendStipendsStipendIdActionPost>>,
  TError,
  ActionStipendStipendsStipendIdActionPostMutationVariables,
  TContext
> => {
  return useMutation(
    getActionStipendStipendsStipendIdActionPostMutationOptions(options),
    queryClient
  );
};
